import {
    AutocompleteOption,
    GroupOptions,
} from "components/Form/components/Autocomplete/Autocomplete";
import Select from "react-select";
import "../Autocomplete.scss";

export interface SimpleSelectProps {
    optionList: AutocompleteOption[];
    groupOptions?: GroupOptions[];
    selectedValue: any;
}

export const SimpleSelect = ({
    optionList,
    groupOptions,
    selectedValue,
    ...sharedProps
}: SimpleSelectProps) => {
    return (
        <Select
            value={selectedValue}
            options={groupOptions ?? optionList}
            isSearchable={false}
            {...sharedProps}
        />
    );
};
